import { c as _c } from "react/compiler-runtime";
import { Box, Divider, IconButton, Stack, styled, Typography } from '@mui/material';
import { BackupPolicyType, Provider, ScheduleMode, type BackupPolicyConfig, type InventoryBackupPolicy } from '@repo/api-gw-sdk';
import { useState } from 'react';
import { BackupPolicyTypeTag } from '@/app/(dashboard)/settings/backup-policies/backupPolicyTypeTag';
import { getFrequencyByWindow, getFrequencyDisplayName } from '@/app/(dashboard)/settings/frequency';
import type { BackupVault } from '@/data/vaults/backupVault';
import { fromDaysToBiggestAsPossible } from '@/utils/dateTime';
import { SnapshotIndicator } from '../snapshots/SnapshotIndicator';
import { Tag } from '../tag';
import { BackupVaultCard } from '../vaults/backupVaultCard';
import { AccountAsVaultTag } from '../vaults/vaultTag';
const SelectableIconBtn = styled(IconButton)<{
  selected?: boolean;
}>(({
  selected
}) => ({
  border: selected ? `1px solid var(--mui-palette-text-primary)` : 'none',
  padding: '4px',
  margin: selected ? '0 4px' : 'none',
  borderRadius: '50%'
}));
export function BackupPolicyPopperCard(t0) {
  const $ = _c(26);
  const {
    policy,
    vaults
  } = t0;
  const isAzureFiles = policy.policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_FILES;
  const [selectedSchedule, setSelectedSchedule] = useState(policy.schedules.length > 0 ? policy.schedules[0] : null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundColor: "var(--mui-palette-background-paper)",
      boxShadow: "var(--mui-customShadows-panel)",
      width: "368px",
      padding: "24px",
      paddingBottom: "12px",
      borderRadius: "16px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "12px",
      alignItems: "center"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== policy.name) {
    t3 = <Typography variant="h6">{policy.name}</Typography>;
    $[2] = policy.name;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== policy.policyType) {
    t4 = <BackupPolicyTypeTag policyType={policy.policyType} />;
    $[4] = policy.policyType;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== policy.enabled) {
    t5 = !policy.enabled && <Tag content="Disabled" disabled={true} />;
    $[6] = policy.enabled;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <Stack className="mb-[32px]" direction="row" sx={t2}>{t3}{t4}{t5}</Stack>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isAzureFiles || $[13] !== policy || $[14] !== selectedSchedule || $[15] !== vaults) {
    t7 = isAzureFiles ? <AzureFilesPolicyContent selectedSchedule={selectedSchedule} /> : <StandardPolicyContent policy={policy} vaults={vaults} selectedSchedule={selectedSchedule} />;
    $[12] = isAzureFiles;
    $[13] = policy;
    $[14] = selectedSchedule;
    $[15] = vaults;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== isAzureFiles || $[18] !== policy.schedules || $[19] !== selectedSchedule || $[20] !== vaults) {
    t8 = policy?.schedules.length > 1 ? <><Stack direction="row" sx={{
        alignItems: "center",
        justifyContent: "space-between",
        margin: "0 -24px",
        marginTop: "24px",
        padding: "12px 24px",
        paddingBottom: 0,
        borderTop: "1px solid var(--mui-palette-divider)"
      }}><Typography variant="body1">{`${selectedSchedule ? (policy?.schedules.findIndex(p => p.id === selectedSchedule?.id) ?? 0) + 1 : 1} of ${policy?.schedules?.length ?? 0}`}</Typography><Stack direction="row" sx={{
          alignItems: "center",
          gap: "4px"
        }}><IconButton size="small" onClick={() => {
            const currentIndex = selectedSchedule ? policy.schedules.findIndex(s => s.id === selectedSchedule.id) : 0;
            setSelectedSchedule(policy.schedules[(currentIndex - 1 + policy.schedules.length) % policy.schedules.length]);
          }}><i className="material-symbols-chevron-left-rounded" /></IconButton>{policy.schedules.map(schedule => {
            const vault = vaults.find(v => v.id === schedule.vaultId);
            const selected = selectedSchedule?.id === schedule.id;
            return <SelectableIconBtn size="small" key={schedule.id} selected={selected} onClick={() => {
              if (!selected) {
                setSelectedSchedule(schedule);
              }
            }}><SnapshotIndicator backgroundColor={isAzureFiles ? null : vault?.backgroundColor || null} /></SelectableIconBtn>;
          })}<IconButton size="small" onClick={() => {
            const currentIndex_0 = selectedSchedule ? policy.schedules.findIndex(s_0 => s_0.id === selectedSchedule.id) : 0;
            setSelectedSchedule(policy.schedules[(currentIndex_0 + 1) % policy.schedules.length]);
          }}><i className="material-symbols-chevron-right-rounded" /></IconButton></Stack></Stack></> : <div className="mb-[12px]" />;
    $[17] = isAzureFiles;
    $[18] = policy.schedules;
    $[19] = selectedSchedule;
    $[20] = vaults;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t6 || $[23] !== t7 || $[24] !== t8) {
    t9 = <Box onClick={_temp} onMouseDown={_temp2} sx={t1}>{t6}{t7}{t8}</Box>;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}
const AzureFilesPolicyContent = t0 => {
  const $ = _c(17);
  const {
    selectedSchedule
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "16px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Stack direction="row" sx={{
      alignItems: "center",
      gap: "40px"
    }}><Typography className="min-w-[86px]" variant="subtitle1">Frequency</Typography><Typography>Daily</Typography></Stack>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      alignItems: "center",
      gap: "40px"
    };
    t5 = <Typography className="min-w-[86px]" variant="subtitle1">Retention</Typography>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== selectedSchedule) {
    t6 = selectedSchedule?.backupRetention ? formatRetention(selectedSchedule.backupRetention) : "\u2014";
    $[5] = selectedSchedule;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <Stack direction="row" sx={t4}>{t5}<Typography>{t6}</Typography></Stack>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t10;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      alignItems: "center",
      gap: "40px"
    };
    t10 = <Typography className="min-w-[86px]" variant="subtitle1">Stored in</Typography>;
    $[10] = t10;
    $[11] = t9;
  } else {
    t10 = $[10];
    t9 = $[11];
  }
  const t11 = selectedSchedule?.region || "Source region";
  let t12;
  if ($[12] !== t11) {
    t12 = <Stack direction="row" sx={t9}>{t10}<AccountAsVaultTag cloudProvider={Provider.Azure} region={t11} /></Stack>;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t12 || $[15] !== t7) {
    t13 = <Stack sx={t1}>{t2}{t3}{t7}{t8}{t12}</Stack>;
    $[14] = t12;
    $[15] = t7;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  return t13;
};
const StandardPolicyContent = t0 => {
  const $ = _c(30);
  const {
    policy,
    vaults,
    selectedSchedule
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "16px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "start",
      gap: "40px"
    };
    t3 = <Typography className="min-w-[86px]" variant="subtitle1">Frequency</Typography>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      gap: "8px"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = selectedSchedule && getFrequencyByWindow(selectedSchedule.windows)?.text;
  let t6;
  if ($[4] !== t5) {
    t6 = <Typography>{t5}</Typography>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== policy.scheduleMode || $[7] !== selectedSchedule) {
    t7 = policy.scheduleMode === ScheduleMode.SCHEDULE_MODE_ADVANCED && selectedSchedule && <Typography>{getFrequencyDisplayName(selectedSchedule.windows)}</Typography>;
    $[6] = policy.scheduleMode;
    $[7] = selectedSchedule;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <Stack direction="row" sx={t2}>{t3}<Stack sx={t4}>{t6}{t7}</Stack></Stack>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      alignItems: "center",
      gap: "40px"
    };
    t11 = <Typography className="min-w-[86px]" variant="subtitle1">Retention</Typography>;
    $[13] = t10;
    $[14] = t11;
  } else {
    t10 = $[13];
    t11 = $[14];
  }
  let t12;
  if ($[15] !== selectedSchedule) {
    t12 = selectedSchedule?.backupRetention && formatRetention(selectedSchedule.backupRetention);
    $[15] = selectedSchedule;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t12) {
    t13 = <Stack direction="row" sx={t10}>{t11}<Typography>{t12}</Typography></Stack>;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    t15 = <Typography className="min-w-[86px]" variant="subtitle1">Vault</Typography>;
    $[19] = t14;
    $[20] = t15;
  } else {
    t14 = $[19];
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t13 || $[22] !== t8) {
    t16 = <Stack sx={t1}>{t8}{t9}{t13}{t14}{t15}</Stack>;
    $[21] = t13;
    $[22] = t8;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== selectedSchedule || $[25] !== vaults) {
    t17 = <div className="mt-[16px]">{selectedSchedule ? <BackupVaultCard editable={false} data={vaults.find(v => v.id === selectedSchedule.vaultId)} /> : <BackupVaultCard loading={true} editable={false} />}</div>;
    $[24] = selectedSchedule;
    $[25] = vaults;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t16 || $[28] !== t17) {
    t18 = <>{t16}{t17}</>;
    $[27] = t16;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  return t18;
};
const formatRetention = (backupRetention: number) => {
  const formattedRetention = fromDaysToBiggestAsPossible(backupRetention);
  return `${formattedRetention.value} ${formattedRetention.unit}${formattedRetention.unit !== 'days' ? ` (${backupRetention} days)` : ''}`;
};